<template>
  <avs-deleteDialog
    v-model="value"
    @cancel="handleCancel"
    @delete="remove"
    noPrevention
    resource="file"
  />
</template>

<script>
import { MeetingService, PictureService } from "@/services"
import DocumentationService from "@/services/DocumentationService"

export default {
  name: "DialogDeleteFile",
  props: {
    item: {
      type: Object
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    message() {
      return this.$t("messages.information.delete_entity", {
        type: this.$tc("commons.file", 1).toLowerCase(),
        entity: this.item.name
      })
    },
    projectId() {
      return this.$store.state.app.project.id
    }
  },
  methods: {
    async remove() {
      const item = this.item

      // Define promise to use
      let promise = null
      if (item.file_type == "screenshot") {
        promise = PictureService.remove(this, item.id)
      } else if (item.file_type == "video") {
        promise = MeetingService.removeRecordByUrl(item.file_url)
      } else if (item.file_type == "report") {
        promise = DocumentationService.deleteReport(this, this.projectId, item.id)
      } else if (item.file_type == "ged_file") {
        promise = DocumentationService.deleteDocument(this, this.projectId, item.id)
      } else {
        promise = Promise.reject({ message: this.$t("messages.error.invalid_file") })
      }

      // Then processs
      return promise
        .then(response => {
          this.notify(this.$t("messages.success.deleted", { entity: this.$tc("commons.file", 1) }))
          this.$emit("close", true)
          return true
        })
        .catch(error => {
          this.notify(error.message, "error")
          return false
        })
    },
    handleCancel() {
      this.$emit("close", true)
    },
    notify(msg, color = "success") {
      this.$store.commit("app/message", { msg, color })
    }
  }
}
</script>
